// extracted by mini-css-extract-plugin
export default {"textboxContainer":"SearchBox_textboxContainer__6Vx6a"};